"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rogueColors = void 0;
// https://lospec.com/palette-list/japanese-woodblock#comments
exports.rogueColors = {
    none: -1,
    dark: 0x2b2821,
    brown: 0x624c3c,
    peach: 0xd9ac8b,
    light: 0xe3cfb4,
    darkBlue: 0x243d5c,
    blueGray: 0x5d7275,
    lightBlue: 0x5c8b93,
    gray: 0xb1a58d,
    red: 0xb03a48,
    orange: 0xd4804d,
    yellow: 0xe0c872,
    green: 0x3e6958,
    pureBlack: 0x000000,
    pureWhite: 0xffffff,
};
